import axios from "axios";
import { ResponseInterceptor } from "./ResponseInterceptor";
import { ErrorInterceptor } from "./ErrorInterceptor";
import { ErrorInterceptorWebAgenda } from "./ErrorInterceptorWebAgenda";

const API_URL = process.env.REACT_APP_API_URL_SISTEMA;
//console.log(API_URL)
const ApiWebAgenda = axios.create({
    baseURL: API_URL
})



ApiWebAgenda.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

ApiWebAgenda.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('tkc_hsp');
        //   console.log(accessToken)
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }
        return config;
    },
    (error) => ErrorInterceptor(error)
)

ApiWebAgenda.interceptors.response.use(
    (response) => ResponseInterceptor(response),
    (error) => ErrorInterceptorWebAgenda(error)
)

export default ApiWebAgenda;